﻿import {Controller} from "./helpers/controller";
import {shim} from "./helpers/shim";
import {onResize} from "./helpers/resize";

export class lottieAnimationControl extends Controller {

    private timer: number | undefined;
    private mobileCutoffQuery: string = '(min-width: 1023px)';
    private lottieHtml = `<div class="animateHold" ><div class="animatePlay"></div></div>`;
    private animationName: string;
    private animationPath: string = '';
    private loadCompleted: boolean = false;

    constructor(element: HTMLElement) {
        super(element);

        this.animationName = this.$().data().animation;

        if (this.animationName != undefined) {
            this.loadLottie();

            onResize(this.resizeContent, 150);
        }
    }

    playAnimation = () => {

        if (this.loadCompleted) {
            let newAnimationPath: string;

            if (window.matchMedia(this.mobileCutoffQuery).matches) {
                newAnimationPath = `/resources/images/animationJSON/${this.animationName}Desktop.json`
            } else {
                newAnimationPath = `/resources/images/animationJSON/${this.animationName}Mobile.json`
            }

            if (newAnimationPath != this.animationPath){
                this.animationPath = newAnimationPath;
                let animationContainer: HTMLElement = this.$().find('.animatePlay').empty().get()[0];
                
                let animation = shim('bodymovin').loadAnimation({
                    container: animationContainer,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: this.animationPath
                })
            }


        }

    }

    public loadLottie = () => {

        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (typeof (shim('bodymovin')) === 'undefined' || typeof (shim('bodymovin').loadAnimation) === 'undefined') {
                if (document.querySelectorAll('#lottie-js').length <= 0) {
                    let tag = document.createElement('script');
                    tag.src = '/resources/lib/lottie.min.js';
                    tag.id = 'lottie-js';
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                }

                this.loadLottie();
            } else {

                this.$().prepend(this.lottieHtml);
                this.loadCompleted = true;

                this.playAnimation()
            }
        }, 50);
    }


    resizeContent = () => {
        this.playAnimation();
    }
    
}